import React from "react";
import useMenu from "./hooks/useMenu";
import "./SchoolMegaMenu.css";
import MegaMenuPanel from "./components/MegaMenuPanel/MegaMenuPanel";
import MegaMenuHeader from "./components/MegaMenuHeader/MegaMenuHeader";
import MegaMenuGrid from "./components/MegaMenuGrid/MegaMenuGrid";
import MegaMenuFooter from "./components/MegaMenuFooter/MegaMenuFooter";
import useNavigation from "./hooks/useNavigation";

const SchoolMegaMenu = () => {
  const {
    activeMenu,
    menuPosition,
    enterMegaMenu,
    leaveMegaMenu,
  } = useNavigation();
  const { getMegaMenu } = useMenu();

  const megaMenu = getMegaMenu(activeMenu);
  const hasHeader = !!(
    megaMenu?.title ||
    megaMenu?.viewAll
  );

  const hasFooter = !!(
    megaMenu?.footer &&
    (
      megaMenu.footer.title ||
      megaMenu.footer.description ||
      megaMenu.footer.action
    )
  );
  if (!megaMenu) {
    return null;
  }

  const COLUMN_WIDTH = 300;
  const MAX_WIDTH = 1400;
  const SIDE_MARGIN = 32;
  const viewportWidth = document.documentElement.clientWidth;

  const panelWidth = Math.min(
    megaMenu.sections.length * COLUMN_WIDTH,
    MAX_WIDTH,
    viewportWidth - SIDE_MARGIN
  );
  const ANCHOR_OFFSET = 0.30;

  let left =
    menuPosition.left +
    menuPosition.width / 2 -
    panelWidth * ANCHOR_OFFSET;

  left = Math.max(16, left);

  left = Math.min(
    left,
    window.innerWidth - panelWidth - 16
  );
  return (
    <div 
      className="school-mega-menu"
      onMouseEnter={enterMegaMenu}
      onMouseLeave={leaveMegaMenu}
      style={{
          // left: menuPosition.left,
          left
      }}
    >
      <MegaMenuPanel
        style={{
          width: panelWidth,
        }}
        body={
          <>
            {hasHeader && <MegaMenuHeader menu={megaMenu} />}
            <MegaMenuGrid menu={megaMenu} />
          </>
        }
        footer={
          hasFooter && (
            <MegaMenuFooter menu={megaMenu} />
          )
        }
      />
    </div>
  );
};

export default SchoolMegaMenu;
